document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('newsletter-popup-overlay');
  if (!overlay) return;

  const closeBtn = overlay.querySelector('.newsletter-popup-close');
  const STORAGE_KEY = 'newsletterPopupClosed';

  function shouldShow() {
    return !sessionStorage.getItem(STORAGE_KEY);
  }

  function showPopup() {
    overlay.hidden = false;
  }

  function hidePopup() {
    overlay.hidden = true;
    sessionStorage.setItem(STORAGE_KEY, 'true');
  }

  if (shouldShow()) {
    setTimeout(showPopup, 4000); // apparaît après 4s — ajustable
  }

  closeBtn.addEventListener('click', hidePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) hidePopup();
  });
});